<template>
  <div>

  </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";

import Expense from "./Expense.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

const EVT_CREATE = "expenseCreate";
const EVT_UPDATE = "expenseUpdate";

const URL_CREATE = "/api/v1/rent/expense/create";
const URL_UPDATE = "/api/v1/rent/expense/update";

export default {
  name: "ExpenseCreateUpdate",
  components: { Alert, Button, DateTime, InputText, InputDecimal, Loading, Select },
  props: {
    rent: {
      type: Object,
      required: true,
      validator: (v) => v && typeof v.id !== "undefined"
    }
  },
  data() {
    return {
      formName: "expenseCreateUpdate",
      expense: new Expense(),
      urlCreate: URL_CREATE,
      urlUpdate: URL_UPDATE,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    isEditing() {
      return !!(this.expense && this.expense.id);
    }
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    async save() {
      this.expense.rentId = this.rent.id;
      this.loading = true;
      try {
        const isEdit = this.isEditing;
        const params = {
          url: isEdit ? this.urlUpdate : this.urlCreate,
          obj: this.expense
        };

        const response = isEdit ? await this.putApi(params) : await this.postApi(params);

        this.removeLoading(["saveExpense"]);

        if (response && response.success) {
          this.hideModal();
          this.resetValidation(this.formName);
        }
      }
      finally {
        this.loading = false;
      }
    },
    update(data) {
      const instance = new Expense();
      instance.update(data);
      this.expense = instance;
    }
  },
  watch: {
    event: {
      deep: true,
      handler(ev) {
        if (!ev || !ev.name) return;

        if (ev.name === EVT_CREATE) {
          this.loading = true;
          this.expense = new Expense();
          this.resetValidation(this.formName);
          this.loading = false;
          return;
        }

        if (ev.name === EVT_UPDATE) {
          this.loading = true;
          this.update(ev.data);
          this.resetValidation(this.formName);
          this.loading = false;
          return;
        }
      }
    }
  }
};
</script>
